import Vue from 'vue';
import router from './router/index';
import store from './store/store';

import './assets/css/main.scss';
import './assets/css/main.css';
import ElementUI from 'element-ui'
// import '../node_modules/element-ui/lib/theme-chalk/index.css'
import './assets/css/element-variables.scss'
// 自定义控件
import kUI from './components/index';
import './common/util';
import setting from './config/settings';

import axios from './common/axios';
import 'lodash';
import moment from 'moment';

// import localforage from './common/localForage';
// import VeeValidate from 'vee-validate';

import App from './App';

Vue.prototype.$http = axios;
Vue.prototype.$setting = setting;
window.moment = moment;
window.moment.locale('zh-cn', setting.MOMENT_RELATIVETIME);
// window.localforage = localforage;

// 来关闭生产模式下给出的提示
Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(kUI);
// Vue.use(VeeValidate);
/* eslint-disable no-new */
let vm = new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
})

window.vue = vm;



// WEBPACK FOOTER //
// ./src/main.js